<app-unauth-main-layout
  [desktopVideoUrl]="desktopBackgroundVideo"
  [tabletVideoUrl]="tabletBackgroundVideo"
  [mobileVideoUrl]="mobileBackgroundVideo"
  [showStamp]="!verificationSent && !isMobile"
  ><div [ngClass]="verificationSent ? 'content-wrapper-reset' : 'content-wrapper'">
    <div [innerHTML]="body | safeHtml" *ngIf="!verificationSent"></div>
    <div [innerHTML]="body2 | safeHtml" *ngIf="verificationSent"></div>
    <form
      [formGroup]="formGroup"
      class="d-flex flex-column align-items-start justify-content-start w-100"
      (ngSubmit)="onSubmit()"
    >
      <div class="form-row p-1 w-100 d-block" *ngIf="!verificationSent">
        <label class="fw-bold">Email</label>
        <input id="email" type="text" formControlName="email" placeholder="Email Address" class="w-100 form-control" />
      </div>
      <div class="form-row p-1 w-100 d-block" *ngIf="verificationSent">
        <label class="fw-bold">Verification code</label>
        <input
          id="verificationCode"
          type="text"
          formControlName="verificationCode"
          placeholder="Verification code"
          class="w-100 form-control"
        />
      </div>
      <div class="form-row p-1 w-100 d-block" *ngIf="verificationSent">
        <label class="fw-bold">New password</label>
        <input
          id="newPassword"
          type="password"
          formControlName="newPassword"
          placeholder="New password"
          class="w-100 form-control"
        />
        <p class="mt-2 password-rules">
          {{ 'password_rules_text' | translate }}
        </p>
      </div>
      <div class="form-row p-1 w-100 d-block" *ngIf="verificationSent">
        <label class="fw-bold">Confirm password</label>
        <input
          id="confirmedPassword"
          type="password"
          formControlName="confirmedPassword"
          placeholder="Confirm password"
          class="w-100 form-control"
        />
      </div>
      <div class="form-row w-75 d-block">
        <div class="d-flex flex-column align-items-start justify-content-center w-100">
          <button
            class="btn btn-primary btn-round"
            [ngClass]="verificationSent ? 'btn-forgot-sent' : 'btn-forgot'"
            type="submit"
          >
            {{ verificationSent ? 'Reset Password' : 'Get Verification Code' }}
          </button>
          <a [ngClass]="verificationSent ? 'back-to-login-sent' : 'back-to-login'" routerLink="/auth/login"
            >Back to Login</a
          >
        </div>
      </div>
    </form>
  </div>
</app-unauth-main-layout>
